import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { XCircle, ArrowLeft, CreditCard } from "lucide-react";

const PaymentCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      {/* Paper texture */}
      <div className="fixed inset-0 paper-texture pointer-events-none" />
      
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center">
          <div className="space-y-6">
            <div className="w-20 h-20 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center mx-auto">
              <XCircle className="w-12 h-12 text-red-600 dark:text-red-400" />
            </div>
            <div className="space-y-2">
              <h1 className="text-2xl font-bold text-foreground">
                Payment Cancelled
              </h1>
              <p className="text-muted-foreground">
                Your payment was cancelled. No charges were made to your account.
              </p>
            </div>
            <div className="space-y-3">
              <Button
                size="lg"
                className="w-full h-14 text-lg rounded-xl"
                onClick={() => navigate("/pricing")}
                data-testid="try-again-btn"
              >
                <CreditCard className="w-5 h-5 mr-2" />
                Try Again
              </Button>
              <Button
                variant="outline"
                size="lg"
                className="w-full h-14 text-lg rounded-xl"
                onClick={() => navigate("/explore")}
                data-testid="back-to-map-btn"
              >
                <ArrowLeft className="w-5 h-5 mr-2" />
                Back to Map
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancelPage;
